import Observer from '~/utils/lib/core/observer'

/**
 * @constant {string}
 * @default
 */
export const STORE_PREFIX = 'base'

/** @constant {string} */
export const baseURL = import.meta.env.VITE_BASE_API_URL

/**
 * @typedef {object} RequestConstructorParams
 * @property {string} options.method
 * @property {string} options.route
 * @property {object} [options.data]
 * @property {object} [options.params] will hydrate URL params
 */

/**
 * @typedef {object} RequestResponse
 * @property {*} data
 * @property {number} status
 * @property {string} statusText
 * @property {object} headers
 * @property {RequestConfig} config
 * @property {XMLHttpRequest} request
 * @link https://axios-http.com/docs/res_schema
 */

/**
 * @typedef {Error & {
 *    config: RequestConfig
 *    isAxiosError: boolean
 *    request?: XMLHttpRequest
 *    response?: RequestResponse
 * }} RequestError
 * @desc extending `Error` with instance extra properties
 * @link https://axios-http.com/docs/handling_errors
 */

/**
 * @typedef {import('axios').AxiosRequestConfig & {
 *  withAuthorization: boolean;
 *  execCount: number;
 * }} RequestConfig
 * @desc extending Axios config with extra config properties
 * @link https://axios-http.com/docs/req_config
 */

/** @type {Observer} */
export const observer = new Observer()

/** @constant {object} */
export const ERRORS = {
  REQUEST_RESPONSE_UNKNOWN_SCHEMA: '<RequestError> with unknown schema',
  REQUEST_RESPONSE_UNKNOWN_DATA: '<RequestError.data> with unknown schema',
  REQUEST_RESPONSE_UNKNOWN_MESSAGE: '<RequestError.data> with unknown "message"',
  REQUEST_RESPONSE_UNKNOWN_CAUSE: '<RequestError.data> with unknown "cause"',
}

/**
 * @constant {object}
 * @readonly
 */
export const MICRO_SERVICE_ERRORS = /** @type {const} */ ({
  MISC: 'miscelleanous micro service error returned',
})
